 $(document).on('click', '.js-copy-button', function () {
    const $btn = $(this);
    const $parent = $btn.parent();

    const $tooltip = $parent.find('.success__tooltip');
    const $text = $parent.find('span.text');

    const text = $text.attr('data-text') || $text.text().trim();

    if (!text) {
        console.warn('Nothing to copy');
        return;
    }

    const copied = copyToClipboard(text);

    if (!copied) {
        console.error('Copy failed');
        return;
    }

    $btn.addClass('active');
    $parent.addClass('active');
    $tooltip.addClass('active');
    $text.addClass('active');

    setTimeout(() => {
        $tooltip.removeClass('active');
    }, 2500);
});

function copyToClipboard(text) {
    const textarea = document.createElement('textarea');

    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.top = '0';
    textarea.style.left = '0';
    textarea.style.opacity = '0';

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    let success = false;

    try {
        success = document.execCommand('copy');
    } catch (e) {
        console.error('execCommand error:', e);
    }

    document.body.removeChild(textarea);

    return success;
}
